<template>
  <page-wrapper ref="pageEl" title="ส่วนลด RJ Store & Partner">
    <div ref="page-container" class="page-container row">
      <div class="report-filter col-12">
        <div class="form">
          <div class="section">
            <div>
              <div class="label">วันที่แลก Voucher</div>
              <date-picker
                v-model="redeemedDateRange"
                :disabled="!isDropdownDisabled"
                type="daterange"
              ></date-picker>
            </div>
            <div>
              <div class="label">วันที่ใช้ Voucher</div>
              <date-picker
                v-model="usedDateRange"
                :disabled="!isDropdownDisabled"
                type="daterange"
              ></date-picker>
            </div>
          </div>

          <div class="section" col="3">
            <div>
              <div class="label">ประเภทของ Voucher</div>
              <el-select
                v-model="selectedVoucherType"
                :disabled="!isDropdownDisabled"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="(t, idx) in filterVoucherType"
                  :key="idx"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="label">สถานะของ Voucher</div>
              <el-select
                v-model="selectedVoucherStatus"
                :disabled="!isDropdownDisabled"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="(t, idx) in filterVoucherStatus"
                  :key="idx"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="label">Cost Center (ontop)</div>
              <SelectUniqueCostCenter
                v-model="selectedCostCenter"
                :is-disabled="isDropdownDisabled"
              />
            </div>
          </div>

          <div style="display: flex; justify-content: center">
            <el-button
              :disabled="!isSearchDisabled"
              type="primary"
              @click="handleSearch"
            >
              ค้นหา
            </el-button>

            <el-button
              :disabled="!isClickDownloadAsCSVDisabled"
              type="info"
              @click.prevent="downloadFileReport"
            >
              ดาวน์โหลด
            </el-button>

            <el-button
              :disabled="!isClearDisabled"
              plain
              type="danger"
              @click="handleClickClear"
            >
              รีเซ็ต
            </el-button>
          </div>
        </div>
      </div>

      <div class="report-content col-12">
        <div v-show="latest_update_time != null" class="report-header">
          <div>
            <b>รายงานอัปเดต</b>
            <p>
              {{ latest_update_message }}
            </p>
          </div>
          <div>
            <div>
              <p>
                {{ totalCount }}
              </p>
            </div>
            <div align="right">
              <el-button
                v-for="i in [10, 20, 30]"
                :key="i"
                :type="limit == i ? 'primary' : ''"
                circle
                size="small"
                @click="limit = i"
              >
                {{ i }}
              </el-button>
            </div>
          </div>
        </div>

        <!-- Data Table -->
        <div>
          <DataTable :data="reports" :headers="headers" :loading="tableLoading">
          </DataTable>
        </div>

        <div style="text-align: center">
          <el-pagination
            :total="total"
            :disabled="!isPaginationDisable"
            :current-page="page"
            :page-size="limit"
            background
            layout="
              prev, pager, next
            "
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { DateTime } from "luxon"
import PageWrapper from "@/lib/components/PageWrapper"
import DatePicker from "@/lib/components/DatePicker"
import { baanRueJaiClient } from "@/dependencies"
import { formatOrFallbackToInput } from "@/lib/dateTime"
import DataTable from "@/lib/components/DataTable"
import SelectUniqueCostCenter from "../components/SelectUniqueCostCenter"

import {
  formatTotalPagination,
  stringsToDates,
  datesToStrings,
} from "../../../lib/util"

export default {
  components: {
    PageWrapper,
    DatePicker,
    DataTable,
    SelectUniqueCostCenter,
  },
  data() {
    // Select option parameter
    const filterVoucherType = [
      { label: "ทั้งหมด", value: undefined },
      { label: "ซื้อของบน RJ Store", value: "RJ_STORE" },
      { label: "แลกบัตรกำนัล Partner", value: "PARTNER" },
      { label: "แลกรางวัล Lucky Draw", value: "LUCKY_DRAW" },
    ];
    const filterVoucherStatus = [
      { label: "ทั้งหมด", value: undefined },
      { label: "Redeemed", value: "REDEEMED" },
      { label: "Used", value: "USED" },
      { label: "Expired", value: "EXPIRED" },
    ]
    const filterCostCenter = [{ label: "ทั้งหมด", value: undefined }]

    // Header
    const headers = [
      {
        label: "วันที่แลก Voucher",
        value: "created_at",
      },
      {
        label: "วันที่ใช้ Voucher",
        value: "used_at",
      },
      {
        label: "รายการ Voucher ที่แลก",
        value: "item_title",
      },
      {
        label: "รายการสินค้า/ บริการที่ใช้",
        value: "product_title",
      },
      {
        label: 'ประเภทของ Voucher',
        value: 'redeem_type'
      },
      {
        label: "ID ลูกค้าที่แลก",
        value: "redeemed_user_id",
      },
      {
        label: "ชื่อลูกค้าที่แลก",
        value: "redeemed_username",
      },
      {
        label: "ID ลูกค้าที่ใช้",
        value: "used_user_id",
      },
      {
        label: "ชื่อลูกค้าที่ใช้",
        value: "used_username",
      },
      {
        label: "เบอร์โทร",
        value: "user_mobile_number",
      },
      {
        label: "โครงการ",
        value: "redeemed_project_code",
      },
      {
        label: "บ้านเลขที่",
        value: "redeemed_address_no",
      },
      {
        label: "จำนวน MNC ที่ใช้",
        value: "coin_amount_used",
      },
      {
        label: "ราคา MNC (บาท)",
        value: "coin_to_baht",
      },
      {
        label: "ราคาสินค้า/บริการ",
        value: "product_price",
      },
      {
        label: "วันที่ Voucher หมดอายุ",
        value: "item_expired_at",
      },
      {
        label: "สถานะของ Voucher",
        value: "redeem_code_status",
      },
      {
        label: "Cost Center (ontop)",
        value: "item_cost_center",
      },
      {
        label: "Price (ontop)",
        value: "item_price",
      },
      {
        label: "Code",
        value: "code",
      },
    ]

    // Group parameter
    const filterInput = {
      filterCostCenter,
      filterVoucherType,
      filterVoucherStatus,
    }
    const selectedInput = {
      redeemedDateRange: [],
      usedDateRange: [],
      selectedVoucherType: "",
      selectedVoucherStatus: "",
      selectedCostCenter: "",
    }
    const inputCondition = {
      isDropdownDisabled: true,
      isSearchDisabled: true,
      isClickDownloadWithIncentiveAsCSVDisabled: true,
      isClickDownloadAsCSVDisabled: true,
      isClearDisabled: true,
      isPaginationDisable: true,
    }
    const pagination = {
      page: 1,
      limit: 10,
      total: 0,
      latest_update_time: "",
    }

    // Define page parameter
    return {
      ...inputCondition,
      ...filterInput,
      ...selectedInput,
      ...pagination,
      reports: [],
      headers,
      reportType: "redeemed",
      tableLoading: false,
    }
  },
  computed: {
    totalCount() {
      // Get total report count for pagination
      return formatTotalPagination(
        this.reports.length,
        this.page,
        this.total,
        this.limit,
      )
    },
    queryParams() {
      const {
        redeemedDateRange,
        usedDateRange,
        selectedVoucherType,
        selectedVoucherStatus,
        selectedCostCenter,
        page,
        limit,
      } = this.$route.query
      return {
        created_at: datesToStrings(redeemedDateRange),
        used_at: datesToStrings(usedDateRange),
        redeem_type: selectedVoucherType,
        voucher_status: selectedVoucherStatus,
        item_cost_center: selectedCostCenter,
        page: (page && +page) || 1,
        limit: limit || this.limit,
      }
    },
    latest_update_message() {
      const format = "dd MMMM yyyy HH:mm น."
      return this.formatDateToTH(this.latest_update_time, format)
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.setupData()
      this.$refs.pageEl.$el.querySelector(".page-container").scrollTop = 0
    },
    async limit(from, to) {
      if (from !== to) {
        await this.queryData()
      }
    },
  },
  created() {
    this.setupData()
  },
  methods: {
    setupData() {
      this.queryBuilder()
      this.queryData()
    },
    queryBuilder() {
      const {
        redeemedDateRange,
        usedDateRange,
        selectedVoucherType,
        selectedVoucherStatus,
        selectedCostCenter,
        page,
        limit,
      } = this.$route.query
      this.redeemedDateRange = stringsToDates(redeemedDateRange)
      this.usedDateRange = stringsToDates(usedDateRange)
      this.selectedVoucherType = selectedVoucherType
      this.selectedVoucherStatus = selectedVoucherStatus
      this.selectedCostCenter = selectedCostCenter
      this.page = (page && +page) || 1
      this.limit = limit || this.limit
    },
    handleSearch() {
      const {
        redeemedDateRange,
        usedDateRange,
        selectedVoucherType,
        selectedVoucherStatus,
        selectedCostCenter,
        limit,
      } = this

      let query = {
        redeemedDateRange: datesToStrings(redeemedDateRange),
        usedDateRange: datesToStrings(usedDateRange),
        selectedVoucherType,
        selectedVoucherStatus,
        selectedCostCenter,
        page: 1,
        limit,
      }

      // filter out null value
      query = Object.fromEntries(
        Object.entries(query).filter(([, value]) => value),
      )

      // replace route with query string
      const route = {
        name: this.$route.name,
        query,
      }
      this.$router.replace(route)
    },
    handleClickClear() {
      const route = {
        name: this.$route.name,
      }
      this.$router.replace(route)
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page: (page && +page) || 1 },
      }
      this.$router.replace(route)
    },
    async queryData() {
      this.tableLoading = true
      const query = this.queryParams
      await baanRueJaiClient.admin.redeem
        .getRedeemTransactionReport(query, this.reportType)
        .then((response) => {
          const { result } = response.data
          this.reports = result.reports
          this.total = result.total
          this.latest_update_time = result.timestamp ? result.timestamp : null
        })
        .catch((error) => {
          const message = error.response
            ? error.response.data.message
            : error.message
          this.$message.error(
            `ไม่สามารถดู Report ได้เนื่องจาก "${message || "ไม่พบข้อมูล"}"`,
          )
          // eslint-disable-next-line no-console
          console.error(error)
        })
        .finally(() => {
          this.isAbleButton()
          this.tableLoading = false
        })
    },
    async downloadFileReport(event) {
      // get date format 2023-11-06-161249
      const dateFilename = DateTime.utc()
        .setZone("Asia/Bangkok")
        .toFormat("yyyy-MM-dd-HHmmss")

      // Init file name for download report
      const fileName = `${dateFilename}-voucher-exchange-reports.xlsx`
      event.preventDefault()
      this.isDisableButton()

      // Init request params
      const query = this.queryParams
      delete query.page

      // Send request
      const response =
        await baanRueJaiClient.admin.redeem.downloadRedeemTransactionReport(
          query,
          this.reportType,
        )

      // check response before download
      if (response.data) {
        const blob = new Blob([response.data])
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
      }
      this.isAbleButton()
    },
    isDisableButton() {
      this.isSearchDisabled = false
      this.isClearDisabled = false
      this.isClickDownloadAsCSVDisabled = false
      this.isClickDownloadWithIncentiveAsCSVDisabled = false
      this.isPaginationDisable = false
      this.isDropdownDisabled = false
    },
    isAbleButton() {
      this.isSearchDisabled = true
      this.isClearDisabled = true
      this.isClickDownloadAsCSVDisabled = true
      this.isClickDownloadWithIncentiveAsCSVDisabled = true
      this.isPaginationDisable = true
      this.isDropdownDisabled = true
    },
    formatDateToTH(date, format) {
      return formatOrFallbackToInput(date, format)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  z-index: 1;
}

.page-container {
  padding: 15px;
}

.report-row:first-child {
  position: sticky;
  top: 0;

  .report-first-price-cell,
  .report-price-cell,
  .report-cell {
    padding: 10px;
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
  }
}

.report-cell {
  a {
    text-decoration: underline;
  }

  padding: 5px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);

  &:empty::before {
    content: "N/A";
    color: #d8d8d8;
  }
}

.page-container {
  padding: 1rem;
  margin: 0;
}

.report-filter {
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.report-filter .form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form .section {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
}

.form .section[col="3"] {
  grid-template-columns: repeat(3, 1fr);
}

.label {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.report-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.report-content .report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-button.el-button--danger.is-plain:hover,
.el-button.el-button--danger.is-plain:focus {
  color: white !important;
}

@media screen and (max-width: 640px) {
  .form .section,
  .form .section[col="3"] {
    grid-template-columns: 1fr;
  }

  .report-filter {
    margin-bottom: 1rem;
  }
}

.el-input__inner {
  text-align: center;
}
</style>
